import { render, staticRenderFns } from "./refAddComponentDialog.vue?vue&type=template&id=51b5f635&scoped=true"
import script from "./refAddComponentDialog.vue?vue&type=script&lang=js"
export * from "./refAddComponentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b5f635",
  null
  
)

export default component.exports